/**
 * The typing box survives a reload (owner 28 ก.ย. 69 "เก็บร่างไว้"): each chat's unsent text is kept in this
 * browser only (localStorage, per device), for 7 days, and removed when it is sent or cleared. Plain text only — where
 * it came from (canned / AI draft) is not kept. Storage can be missing or refuse (private window): then nothing is kept.
 */
const PREFIX = 'cf-chat.reply-draft.'
export const REPLY_DRAFT_TTL_MS = 7 * 86_400_000
const MAX_CHARS = 5000

function store(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

export function loadReplyDraft(convId: string, now = Date.now()): string {
  const s = store()
  if (!s) return ''
  try {
    const raw = s.getItem(PREFIX + convId)
    if (!raw) return ''
    const v = JSON.parse(raw) as { t?: unknown; at?: unknown }
    if (typeof v.t !== 'string' || typeof v.at !== 'number' || now - v.at > REPLY_DRAFT_TTL_MS) {
      s.removeItem(PREFIX + convId)
      return ''
    }
    return v.t
  } catch {
    return ''
  }
}

export function saveReplyDraft(convId: string, text: string, now = Date.now()): void {
  const s = store()
  if (!s) return
  try {
    if (text.trim()) s.setItem(PREFIX + convId, JSON.stringify({ t: text.slice(0, MAX_CHARS), at: now }))
    else s.removeItem(PREFIX + convId)
  } catch {
    // full or refused: the draft just is not kept
  }
}

/** Drops drafts older than the TTL (called once per page load). */
export function pruneReplyDrafts(now = Date.now()): void {
  const s = store()
  if (!s) return
  try {
    for (let i = s.length - 1; i >= 0; i--) {
      const k = s.key(i)
      if (k?.startsWith(PREFIX)) loadReplyDraft(k.slice(PREFIX.length), now)
    }
  } catch {
    // nothing to do
  }
}
